import { render, staticRenderFns } from "./WithdrawTransaction.vue?vue&type=template&id=0574f3f4"
import script from "./WithdrawTransaction.vue?vue&type=script&lang=js"
export * from "./WithdrawTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports